"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@/app/providers/i18n-provider";
import { useAllCountriesQuery } from "@/entities/country/model/use-countries";
import { PostHogAnalyticsProvider } from "@/shared/analytics";
import { retryOn404, retryOn404Delay } from "@/shared/api/common";
import { AuthProvider, useAuth } from "@/shared/auth/use-auth";
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: retryOn404,
        retryDelay: retryOn404Delay
      },
      mutations: {
        retry: 0
      }
    }
  });
}
let browserQueryClient: QueryClient | null = null;
function getQueryClient() {
  if (typeof window === "undefined") {
    return createQueryClient();
  }
  browserQueryClient ??= createQueryClient();
  return browserQueryClient;
}
function CountriesBootstrapper() {
  const $ = _c(2);
  const {
    isAuthenticated,
    isHydrated
  } = useAuth();
  const t0 = isHydrated && isAuthenticated;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useAllCountriesQuery(t1);
  return null;
}
export function AppProviders(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CountriesBootstrapper />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <PostHogAnalyticsProvider><QueryClientProvider client={queryClient}><I18nProvider><AuthProvider>{t2}{children}</AuthProvider></I18nProvider></QueryClientProvider></PostHogAnalyticsProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}